import { Box, Stack, TextField, Button, Tooltip, Typography, Autocomplete, FormControlLabel, Checkbox, IconButton, FormControl, InputLabel, Select, MenuItem } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Colors } from '../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import { CommonGridToolBarWithFilterText, DeletePopup, CommonDeleteButton, CommonEditButton } from '../../../Components/Common Components/CommonComponents'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import { useHistory, useLocation } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import Loader from '../../../Components/Loader'
import { CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions'
import { uomUnitOptions } from '../../../Utility/Constants';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';

const default_combination = {
    drug_id: null,
    drug_name: "",
    quantity: "",
    uom: "nos",
    loose_uom: "",
    is_billable: false,
    medicineList: []
}

const default_medicine = {
    drug_id: null,
    drug_name: "",
    quantity: "",
    uom: "nos",
    loose_uom: "",
    is_billable: false,
    combinations: [],
    medicineList: []
}

export default function AddMedicineMapping() {
    const location = useLocation();
    const TempId = location.state?.id; // mapping record id (e.g. 35) - sent in edit POST
    const treatmentMsIdFromState = location.state?.treatment_ms_id; // therapy master id - for therapy fetch
    const history = useHistory();
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [formState, setFormState] = useState({
        therapyList: [],
        therapyCode: '',
        therapyName: null,
        medicineRow: { ...default_medicine }
    });
    const [isActive, setIsActive] = useState(true);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [isloader, setisloader] = useState(false);
    const [delIDs, setdelIDs] = useState([]);
    const [CheckBoxList, setCheckBoxList] = useState([]);
    const [isDelete, setisDelete] = useState(false);
    const [medicineDetails, setMedicineDetails] = useState([]);
    const [medicineLineItem, setMedicineLineItem] = useState(null)
    const [apiDeleteIDs, setapiDeleteIDs] = useState(null)
    const [localDeleteIDs, setlocalDeleteIDs] = useState(null)
    const [deleteRow, setDeleteRow] = useState(null)
    const [searchTimeout, setSearchTimeout] = useState(null)
    const [editingDrugSno, setEditingDrugSno] = useState(null) // when set, form is in "edit this drug" mode
    const [deleteCombRow, setDeleteCombRow] = useState(null) // { mainSno, combIndex, combId } for combo-only delete
    let commonDisable = CheckAccessFunc("front_office", "Settings", "Therapy Configuration", "Therapy Medicine Mapping", "SubTab")?.editAccess

    useEffect(() => {
        if (TempId) {
            getMedicineMappingIndividual();
        }
    }, [TempId]);

    useEffect(() => {
        getTherapyData();
    }, []);

    const transformDrugsToMedicineDetails = (drugs) => {
        return (drugs || []).map((drug, index) => ({
            id: drug.id ?? null,
            drug_id: drug.drug_id,
            drug_name: drug.drug_name ?? drug.medicine_name ?? drug.name ?? "",
            quantity: drug.quantity,
            uom: drug.uom,
            loose_uom: drug.loose_uom || drug.min_uom || "",
            is_billable: drug.is_billable || false,
            combinations: (drug.combinations || []).map(comb => ({
                ...default_combination,
                id: comb.id ?? null,
                drug_id: comb.drug_id,
                drug_name: comb.drug_name ?? comb.medicine_name ?? comb.name ?? "",
                quantity: comb.quantity,
                uom: comb.uom,
                loose_uom: comb.loose_uom || comb.min_uom || "",
                is_billable: comb.is_billable ?? false
            })),
            sno: index + 1
        }));
    };

    const getMedicineMappingIndividual = () => {
        setisloader(true);
        const therapyDetails = location.state?.TherapyDetails;
        const hasDrugsFromProps = Array.isArray(therapyDetails?.drugs) && therapyDetails.drugs.length > 0;

        if (hasDrugsFromProps) {
            setFormState((prevState) => ({
                ...prevState,
                therapyName: {
                    id: therapyDetails.treatment_ms_id,
                    treatment_name: therapyDetails.treatment_name || '',
                    treatment_code: therapyDetails.treatment_code || '',
                },
                therapyCode: therapyDetails.treatment_code || '',
            }));
            const transformedDrugs = transformDrugsToMedicineDetails(therapyDetails.drugs);
            setMedicineDetails(transformedDrugs);
            const medicineIds = transformedDrugs.map(item => item.drug_id).filter(id => id != null);
            setMedicineLineItem(medicineIds);
            setIsActive(therapyDetails.is_active !== undefined ? therapyDetails.is_active : true);
            setisloader(false);
            return;
        }

        if (!TempId) {
            setisloader(false);
            return;
        }
    }

    const getTherapyData = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.AYURVEDA_TREATMENT_MASTER)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setisloader(false)
                        const activeTherapies = response?.data?.data?.filter(item => item.is_active) || [];
                        setFormState((prevState) => ({
                            ...prevState,
                            therapyList: activeTherapies
                        }));
                        if (activeTherapies.length > 0 && !location.state?.TherapyDetails) {
                            let therapy = null;
                            if (TempId && treatmentMsIdFromState != null) {
                                therapy = activeTherapies.find((item) => item?.id === treatmentMsIdFromState || item?.treatment_ms_id === treatmentMsIdFromState || item?.id === Number(treatmentMsIdFromState));
                            }
                            if (therapy) {
                                setFormState((prevState) => ({
                                    ...prevState,
                                    therapyName: therapy,
                                    therapyCode: therapy.treatment_code
                                }));
                            }
                        }
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const getMedicineSearchData = (value, medicineIndex = null, combinationIndex = null) => {
        try {
            if (!value || value.length < 2) {
                if (medicineIndex !== null) {
                    setFormState((prevState) => {
                        const updatedMedicineRow = { ...prevState.medicineRow };
                        updatedMedicineRow.medicineList = [];
                        return { ...prevState, medicineRow: updatedMedicineRow };
                    });
                }
                return;
            }

            if (searchTimeout) {
                clearTimeout(searchTimeout);
            }

            const timeout = setTimeout(() => {
                RestAPIService.getAll(`${Serviceurls.AYURVEDA_MEDICINE_PREPARE_DRUG_SEARCH}?search_key=${encodeURIComponent(value)}`)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            const results = response?.data?.data || [];
                            if (medicineIndex !== null) {
                                // Update medicine list for main medicine
                                setFormState((prevState) => {
                                    const updatedMedicineRow = { ...prevState.medicineRow };
                                    updatedMedicineRow.medicineList = results;
                                    return { ...prevState, medicineRow: updatedMedicineRow };
                                });
                            } else if (combinationIndex !== null) {
                                // Update medicine list for combination
                                setFormState((prevState) => {
                                    const updatedMedicineRow = { ...prevState.medicineRow };
                                    const updatedCombinations = [...updatedMedicineRow.combinations];
                                    updatedCombinations[combinationIndex] = {
                                        ...updatedCombinations[combinationIndex],
                                        medicineList: results
                                    };
                                    updatedMedicineRow.combinations = updatedCombinations;
                                    return { ...prevState, medicineRow: updatedMedicineRow };
                                });
                            }
                        }
                    }).catch(e => {
                        if (e?.response?.data?.status === 'fail') {
                            errorMessage(e.response.data.message)
                        } else {
                            errorMessage(e.message)
                        }
                    })
            }, 300);

            setSearchTimeout(timeout);
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }
    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }


    const onChangeAuto = (e, val, name, combinationIndex = null) => {
        switch (name) {
            case 'therapyName':
                setFormState((prevState) => {
                    const therapyCode = val ? val.treatment_code : '';
                    return {
                        ...prevState,
                        therapyName: val,
                        therapyCode: therapyCode
                    };
                });
                break;
            case 'selectedMedicine':
                if (val) {
                    const drugMsId = val?.drug_ms_id || val?.drug_id;
                    const uom = val?.uom || "nos";
                    const looseUom = val?.loose_uom || val?.min_uom || "";
                    setFormState((prevState) => {
                        const updatedMedicineRow = { ...prevState.medicineRow };
                        updatedMedicineRow.drug_id = drugMsId || null;
                        updatedMedicineRow.drug_name = val?.drug_name || "";
                        updatedMedicineRow.uom = uom;
                        updatedMedicineRow.loose_uom = looseUom;
                        return { ...prevState, medicineRow: updatedMedicineRow };
                    });
                } else {
                    setFormState((prevState) => {
                        const updatedMedicineRow = { ...prevState.medicineRow };
                        updatedMedicineRow.drug_id = null;
                        updatedMedicineRow.drug_name = "";
                        updatedMedicineRow.uom = "nos";
                        updatedMedicineRow.loose_uom = "";
                        return { ...prevState, medicineRow: updatedMedicineRow };
                    });
                }
                break;
            case 'selectedCombinationMedicine':
                if (combinationIndex !== null && combinationIndex !== undefined) {
                    if (val) {
                        const drugMsId = val?.drug_ms_id || val?.drug_id;
                        const uom = val?.uom || "nos";
                        const looseUom = val?.loose_uom || val?.min_uom || "";
                        setFormState((prevState) => {
                            const updatedMedicineRow = { ...prevState.medicineRow };
                            const updatedCombinations = [...updatedMedicineRow.combinations];
                            updatedCombinations[combinationIndex] = {
                                ...updatedCombinations[combinationIndex],
                                drug_id: drugMsId || null,
                                drug_name: val?.drug_name || "",
                                uom,
                                loose_uom: looseUom
                            };
                            updatedMedicineRow.combinations = updatedCombinations;
                            return { ...prevState, medicineRow: updatedMedicineRow };
                        });
                    } else {
                        setFormState((prevState) => {
                            const updatedMedicineRow = { ...prevState.medicineRow };
                            const updatedCombinations = [...updatedMedicineRow.combinations];
                            updatedCombinations[combinationIndex] = {
                                ...updatedCombinations[combinationIndex],
                                drug_id: null,
                                drug_name: "",
                                uom: "nos",
                                loose_uom: ""
                            };
                            updatedMedicineRow.combinations = updatedCombinations;
                            return { ...prevState, medicineRow: updatedMedicineRow };
                        });
                    }
                }
                break;
        }
    }

    const restrictQuantity = (val) => {
        const digitsOnly = String(val || '').replace(/\D/g, '');
        return digitsOnly.length > 5 ? digitsOnly.slice(0, 5) : digitsOnly;
    };

    const updateTableQty = (mainSno, isMainDrug, combIndex, newValue) => {
        const value = restrictQuantity(newValue);
        setMedicineDetails((prev) => prev.map((item) => {
            if (item.sno !== mainSno) return item;
            if (isMainDrug) {
                return { ...item, quantity: value };
            }
            const combinations = [...(item.combinations || [])];
            if (combinations[combIndex] != null) {
                combinations[combIndex] = { ...combinations[combIndex], quantity: value };
            }
            return { ...item, combinations };
        }));
    };

    const onChangeHandler = (e, name, combinationIndex = null) => {
        let { value } = e.target;
        if (name === 'quantity') {
            value = restrictQuantity(value);
        }
        if (combinationIndex !== null) {
            setFormState((prevState) => {
                const updatedMedicineRow = { ...prevState.medicineRow };
                const updatedCombinations = [...updatedMedicineRow.combinations];
                updatedCombinations[combinationIndex] = {
                    ...updatedCombinations[combinationIndex],
                    [name]: value
                };
                updatedMedicineRow.combinations = updatedCombinations;
                return { ...prevState, medicineRow: updatedMedicineRow };
            });
        } else {
            setFormState((prevState) => {
                const updatedMedicineRow = { ...prevState.medicineRow };
                updatedMedicineRow[name] = value;
                return { ...prevState, medicineRow: updatedMedicineRow };
            });
        }
    };

    const getUomOptions = (row) => {
        const options = [...new Set([row?.uom, row?.loose_uom].filter(Boolean))];
        if (options.length > 0) return options;
        if (row?.uom) return [row.uom];
        return (uomUnitOptions && Array.isArray(uomUnitOptions)) ? uomUnitOptions.map((o) => o.value ?? o.label) : [];
    };

    const handleMedicineInputChange = (e, newValue, reason, combinationIndex = null) => {
        if (reason === "input" && newValue) {
            if (combinationIndex !== null) {
                getMedicineSearchData(newValue, null, combinationIndex);
            } else {
                getMedicineSearchData(newValue, 0, null);
            }
        }
    };

    const textBox = (label, name, val, width, disable = false) => {
        return (
            <Box>
                <TextField
                    size='small'
                    name={name}
                    autoComplete='off'
                    disabled={disable}
                    value={val ? val : ""}
                    sx={{ width: width, marginRight: '0.3vw' }}
                    label={label}
                    onChange={(e) => { onChangeHandler(e, name) }}
                    variant="outlined"
                />
            </Box>
        )
    }

    const autoComplete = (label, name, val, list, width, disabled = false, onInputChange = null, combinationIndex = null) => {
        const selectedValue = list?.find((item) => {
            if (name === 'selectedMedicine') {
                return item?.drug_name === val?.drug_name;
            } else if (name === 'selectedCombinationMedicine') {
                return item?.drug_name === val?.drug_name;
            } else if (name === 'therapyName') {
                return item?.treatment_name === val?.treatment_name;
            }
            return false;
        }) || null;

        return (
            <Box>
                <Autocomplete
                    clearIcon
                    size={'small'}
                    options={list}
                    name={name}
                    getOptionLabel={(option) => {
                        if (!option) return '';
                        if (name === 'therapyName') {
                            return option?.treatment_name || '';
                        } else if (name === 'selectedMedicine' || name === 'selectedCombinationMedicine') {
                            return option?.display_name || `${option?.drug_name || ""} - ${option?.generic_name || ""}` || "";
                        }
                        return option;
                    }}
                    value={selectedValue}
                    disabled={disabled}
                    onChange={(event, newValue) => {
                        if (combinationIndex !== null) {
                            onChangeAuto(event, newValue, 'selectedCombinationMedicine', combinationIndex);
                        } else {
                            onChangeAuto(event, newValue, name);
                        }
                    }}
                    onInputChange={onInputChange || undefined}
                    renderInput={(params) => <TextField {...params} label={label} sx={{ width: width, marginRight: '0.3vw' }} />}
                />
            </Box>
        )
    }

    const handleAddCombination = () => {
        const isValid = formState.medicineRow.drug_name && formState.medicineRow.drug_id && formState.medicineRow.quantity;
        if (!isValid) {
            errorMessage("Please fill all mandatory fields for main medicine (Medicine, Quantity)");
            return;
        }

        const isValidCombinations = formState.medicineRow.combinations?.every(item =>
            item?.drug_name && item?.drug_id && item?.quantity
        );

        if (!isValidCombinations) {
            errorMessage("Please fill all mandatory fields for all combination medicines");
            return;
        }

        setFormState((prevState) => {
            const updatedMedicineRow = { ...prevState.medicineRow };
            updatedMedicineRow.combinations = [...updatedMedicineRow.combinations, { ...default_combination }];
            return { ...prevState, medicineRow: updatedMedicineRow };
        });
    }

    const handleDeleteCombination = (index) => {
        setFormState((prevState) => {
            const updatedMedicineRow = { ...prevState.medicineRow };
            const updatedCombinations = [...updatedMedicineRow.combinations];
            updatedCombinations.splice(index, 1);
            updatedMedicineRow.combinations = updatedCombinations;
            return { ...prevState, medicineRow: updatedMedicineRow };
        });
    }

    const grpDelete = () => {
        setisDelete(true)
    }

    const loadDrugIntoForm = (mainSno) => {
        const main = medicineDetails?.find((m) => m.sno === mainSno);
        if (!main) return;
        setFormState((prev) => ({
            ...prev,
            medicineRow: {
                id: main.id ?? null,
                drug_id: main.drug_id,
                drug_name: main.drug_name ?? "",
                quantity: main.quantity,
                uom: main.uom ?? "nos",
                is_billable: main.is_billable ?? false,
                combinations: (main.combinations || []).map((c) => ({
                    id: c.id ?? null,
                    drug_id: c.drug_id,
                    drug_name: c.drug_name ?? "",
                    quantity: c.quantity,
                    uom: c.uom ?? "nos",
                    is_billable: c.is_billable ?? false,
                    loose_uom: c.loose_uom ?? "",
                    medicineList: c.medicineList || []
                })),
                medicineList: main.medicineList || []
            }
        }));
        setEditingDrugSno(mainSno);
    };

    const handleDeleteCombinationInForm = (combIndex) => {
        setFormState((prev) => {
            const combinations = [...(prev.medicineRow.combinations || [])];
            combinations.splice(combIndex, 1);
            return { ...prev, medicineRow: { ...prev.medicineRow, combinations } };
        });
    };

    const tableView = () => {
        const gridToolBar = () => {
            return (
                <Box>
                    <CommonGridToolBarWithFilterText />
                </Box>
            )
        }

        // Assign sno to main drugs and build flat rows: main + combinations per drug group (like DocPrescription)
        medicineDetails?.forEach((element, index) => { element.sno = index + 1; });
        const flatTableRows = [];
        (medicineDetails || []).forEach((main, groupIndex) => {
            flatTableRows.push({
                ...main,
                isMainDrug: true,
                mainDrugId: main.id,
                mainSno: main.sno,
                combIndex: -1,
                groupIndex,
                flatId: `flat-${main.sno}-main`
            });
            (main.combinations || []).forEach((comb, ci) => {
                flatTableRows.push({
                    drug_name: comb.drug_name ?? "",
                    quantity: comb.quantity,
                    uom: comb.uom,
                    is_billable: comb.is_billable ?? false,
                    isMainDrug: false,
                    mainDrugId: main.id,
                    mainSno: main.sno,
                    combIndex: ci,
                    combId: comb.id ?? null,
                    groupIndex,
                    flatId: `flat-${main.sno}-comb-${ci}`
                });
            });
        });


        const columns = [
            {
                field: 'drug_name', headerName: 'Medicine Name', flex: 0.3,
                renderCell: (params) => {
                    const name = params.row.drug_name;
                    const displayName = params.row.isMainDrug ? (name || '-') : `  └ ${name || '-'}`;
                    const text = (name != null && name !== '') ? displayName : (params.row.isMainDrug ? '-' : '  └ -');
                    return text?.length > 50 ?
                        <Tooltip placement="top" title={text}><Typography fontSize={'0.9vw'}>{text?.slice(0, 50) + '...'}</Typography></Tooltip> :
                        <Typography fontSize={'0.9vw'}>{text}</Typography>;
                }
            },
            {
                field: 'quantity', headerName: 'Quantity', flex: 0.1,
                renderCell: (params) => (
                    commonDisable ? (
                        <TextField
                            size="small"
                            value={params.row.quantity ?? ''}
                            onChange={(e) => updateTableQty(params.row.mainSno, params.row.isMainDrug, params.row.combIndex ?? -1, e.target.value)}
                            onClick={(e) => e.stopPropagation()}
                            inputProps={{ maxLength: 5, inputMode: 'numeric', pattern: '[0-9]*', style: { fontSize: '0.9vw' } }}
                            sx={{ width: '100%', '& .MuiInputBase-input': { py: 0.25 } }}
                        />
                    ) : (
                        <Typography fontSize={'0.9vw'}>{params.row.quantity ?? '-'}</Typography>
                    )
                )
            },
            {
                field: 'uom', headerName: 'Unit', flex: 0.1,
                renderCell: (params) => (<Typography fontSize={'0.9vw'}>{params.row.uom ?? '-'}</Typography>)
            },
            {
                field: 'is_billable', headerName: 'Billable', flex: 0.1,
                renderCell: (params) => (
                    <Checkbox
                        checked={params.row.is_billable || false}
                        disabled
                        size="small"
                    />
                )
            },
            {
                field: 'action', headerName: 'Action', flex: 0.12, align: 'center', headerAlign: 'center',
                renderCell: (params) => (
                    params.row.isMainDrug ? (
                        <Stack direction="row" spacing={0.5} alignItems="center" justifyContent="center">
                            <CommonEditButton
                                size="1.5vw"
                                onClick={() => loadDrugIntoForm(params.row.mainSno)}
                            />
                            <CommonDeleteButton
                                size="1.5vw"
                                disable={!commonDisable}
                                onClick={() => setDeleteRow({ id: params.row.mainDrugId, sno: params.row.mainSno })}
                            />
                        </Stack>
                    ) : null
                )
            },
        ];

        return (
            <Box sx={{
                height: '42vh', marginTop: '.5vw',
                '& .MuiDataGrid-row.group-even': { backgroundColor: '#fafafa', borderLeft: '5px solid gray' },
                '& .MuiDataGrid-row.group-odd': { backgroundColor: '#f0f8ff', borderLeft: '5px solid #4da3d4' },
                '& .MuiDataGrid-cell': { borderRight: '1px solid #e0e0e0', display: 'flex', alignItems: 'center' },
                '& .MuiDataGrid-columnHeaders .MuiDataGrid-cell': { borderRight: '1px solid #e0e0e0' }
            }}>
                <DataGrid
                    // checkboxSelection={commonDisable ? true : false}
                    // selectionModel={CheckBoxList}
                    // onSelectionModelChange={(id) => handleTableCheckbox(id)}
                    rows={flatTableRows}
                    columns={columns}
                    getRowId={(row) => row.flatId}
                    getRowClassName={(params) => `group-${params.row.groupIndex % 2 === 0 ? 'even' : 'odd'}`}
                    page={page}
                    pageSize={pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    hideFooter
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    onPageChange={(newPage) => { setpage(newPage) }}
                    onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    headerHeight={40}
                    density='compact'
                    disableSelectionOnClick
                    loading={isloader}
                />
            </Box>
        )
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    const closeFilter = () => {
        setisDelete(false);
        setCheckBoxList([])
        setdelIDs([])
    }

    const AddTable = () => {
        if (!formState.medicineRow.drug_name || !formState.medicineRow.drug_id) {
            errorMessage("Please select a medicine");
            return;
        }
        if (!formState.medicineRow.quantity || formState.medicineRow.quantity <= 0) {
            errorMessage("Please enter a valid quantity");
            return;
        }
        if (!formState.medicineRow.uom) {
            errorMessage("Please select a unit");
            return;
        }

        const validCombinations = (formState.medicineRow.combinations || []).filter(comb =>
            comb.drug_id && comb.drug_name && comb.quantity && comb.uom
        );

        let newData = {
            id: formState.medicineRow.id ?? null,
            drug_id: formState.medicineRow.drug_id,
            drug_name: formState.medicineRow.drug_name,
            quantity: parseFloat(formState.medicineRow.quantity) || formState.medicineRow.quantity,
            uom: formState.medicineRow.uom,
            is_billable: formState.medicineRow.is_billable,
            combinations: validCombinations.map(comb => ({
                id: comb.id ?? null,
                drug_id: comb.drug_id,
                drug_name: comb.drug_name,
                quantity: parseFloat(comb.quantity) || comb.quantity,
                uom: comb.uom,
                is_billable: comb.is_billable ?? false
            }))
        };

        if (editingDrugSno != null) {
            setMedicineDetails((prevState) =>
                prevState.map((item) => (item.sno === editingDrugSno ? { ...newData, sno: editingDrugSno } : item))
            );
            setEditingDrugSno(null);
            setFormState((prevState) => ({ ...prevState, medicineRow: { ...default_medicine } }));
            return;
        }

        let errorState = false;
        setMedicineDetails((prevState) => {
            if (prevState.some(item => item.drug_id === newData.drug_id)) {
                errorMessage("Medicine already exists!");
                errorState = true;
                return prevState;
            }
            return [...prevState, newData];
        });

        if (!errorState) {
            setFormState((prevState) => ({ ...prevState, medicineRow: { ...default_medicine } }));
        }
    }

    const AddTherapyMappingData = () => {
        if (!formState.therapyName) {
            errorMessage("Please select a therapy name");
            return;
        }
        if (medicineDetails.length === 0) {
            errorMessage("Please add at least one medicine");
            return;
        }

        try {
            const data = {
                id: TempId ? TempId : null,
                treatment_ms_id: formState.therapyName.id,
                is_active: isActive,
                drugs: medicineDetails.map(item => ({
                    id: item.id ?? null,
                    drug_id: item.drug_id,
                    quantity: item.quantity,
                    uom: item.uom,
                    is_billable: item.is_billable,
                    combinations: (item.combinations || []).map(c => ({
                        id: c.id ?? null,
                        drug_id: c.drug_id,
                        quantity: c.quantity,
                        uom: c.uom,
                        is_billable: c.is_billable ?? false
                    }))
                }))
            };

            setisloader(true)
            const apiUrl = Serviceurls.MEDICINE_MAPPING_CONFIGURATION;

            RestAPIService.create(data, apiUrl)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        setisloader(false)
                        history.push("/Settings/TherapyConfig/TherapyMedicineMaster")
                        setTimeout(() => {
                            history.push("/Settings/TherapyConfig/TherapyMedicineMaster");
                        }, 2000);
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const deleteMedicineMapping = async () => {
        try {
            setisloader(true)
            RestAPIService.delete(`${Serviceurls.MEDICINE_MAPPING_CONFIGURATION}?treatment_ms_id=${formState.therapyName?.id ?? treatmentMsIdFromState}`, {})
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const deleteIndivudualData = async () => {
        try {
            setisloader(true);

            if (Array.isArray(delIDs) && Array.isArray(medicineLineItem) && Array.isArray(apiDeleteIDs)) {
                if (((delIDs.length === medicineLineItem.length) || (delIDs.length === medicineDetails.length)) && apiDeleteIDs.length > 0) {
                    await deleteMedicineMapping();
                    return;
                }
            }

            if (localDeleteIDs.length > 0) {
                setMedicineDetails(prevState => prevState.filter(item => !localDeleteIDs.includes(item.sno)));
            }

            if (apiDeleteIDs.length > 0) {
                try {
                    const response = await RestAPIService.delete(
                        `${Serviceurls.MEDICINE_MAPPING_CONFIGURATION}?delete_type=individual&drug_id=${apiDeleteIDs}`,
                        {}
                    );
                    if (response.data.status === 'success') {
                        successMessage(response.data.message);
                        closeFilter();
                        getMedicineMappingIndividual();
                    }
                } catch (e) {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message);
                    } else {
                        errorMessage(e.message);
                    }
                }
            } else {
                closeFilter();
            }
        } catch (e) {
            errorMessage(e.message);
        } finally {
            setisloader(false);
        }
    };

    const deleteSingleRow = async () => {
        if (!deleteRow) return;
        const mainDrugId = deleteRow.id;
        const rowSno = deleteRow.sno;
        try {
            setisloader(true);
            if (mainDrugId != null && mainDrugId !== '') {
                const response = await RestAPIService.delete(
                    `${Serviceurls.MEDICINE_MAPPING_CONFIGURATION}?id=${mainDrugId}`,
                    {}
                );
                if (response.data.status !== 'success') {
                    errorMessage(response.data.message || 'Delete failed');
                    setDeleteRow(null);
                    setisloader(false);
                    return;
                }
                successMessage(response.data.message || 'Deleted');
            }
            setMedicineDetails((prev) =>
                mainDrugId != null && mainDrugId !== ''
                    ? prev.filter((item) => item.id !== mainDrugId)
                    : prev.filter((item) => item.sno !== rowSno)
            );
        } catch (e) {
            if (e?.response?.data?.status === 'fail') {
                errorMessage(e.response.data.message);
            } else {
                errorMessage(e.message || 'Delete failed');
            }
        } finally {
            setisloader(false);
            setDeleteRow(null);
        }
    };

    const deleteSingleCombination = async () => {
        if (!deleteCombRow) return;
        const { mainSno, combIndex, combId } = deleteCombRow;
        try {
            setisloader(true);
            if (combId != null && combId !== '') {
                const response = await RestAPIService.delete(
                    `${Serviceurls.MEDICINE_MAPPING_CONFIGURATION}?combination_id=${combId}`,
                    {}
                );
                if (response.data.status !== 'success') {
                    errorMessage(response.data.message || 'Delete failed');
                    setDeleteCombRow(null);
                    setisloader(false);
                    return;
                }
                successMessage(response.data.message || 'Deleted');
            }
            setMedicineDetails((prev) => prev.map((item) => {
                if (item.sno !== mainSno) return item;
                const combinations = [...(item.combinations || [])];
                combinations.splice(combIndex, 1);
                return { ...item, combinations };
            }));
        } catch (e) {
            if (e?.response?.data?.status === 'fail') {
                errorMessage(e.response.data.message);
            } else {
                errorMessage(e.message || 'Delete failed');
            }
        } finally {
            setisloader(false);
            setDeleteCombRow(null);
        }
    };

    const prevent = () => {
        history.push("/Settings/TherapyConfig/TherapyMedicineMaster");
    };

    const selectedMainMedicine = formState.medicineRow.medicineList?.find(item =>
        item?.drug_name === formState.medicineRow.drug_name
    ) || null;

    return (
        <Box component={'div'} sx={{ height: '85vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box component={'div'} height={'5vh'} display={'flex'} alignItems={'center'} sx={{ backgroundColor: 'white', borderBottom: '1px solid lightgray' }}>
                <IconButton onClick={() => prevent()}>
                    <ChevronLeftIcon color='primary' />
                </IconButton>
                <Typography color={Colors.SecondaryText} fontWeight={600} fontSize={"0.95vw"}>{'Back To Therapy Medicine Mapping'}</Typography>
            </Box>
            <Box component={'div'} sx={{ height: '14vh', width: '93vw', backgroundColor: 'white', mt: "1vw" }}>
                <Box component={'div'} height={'5vh'} display={'flex'} alignItems={'center'} justifyContent={'space-between'} sx={{ backgroundColor: 'white', borderBottom: '1px solid lightgray', paddingLeft: "0.5vw", paddingRight: "0.5vw" }}>
                    <Typography color={Colors.SecondaryText} fontWeight={600} fontSize={"0.95vw"}>{'Therapy Configuration'}</Typography>
                    <Box sx={{ display: 'flex', gap: '0.5vw' }}>
                        {delIDs?.length > 0 && <Button size='small' disabled={!commonDisable} variant='contained' color='error' sx={{ textTransform: 'capitalize', width: '5vw' }} onClick={() => { grpDelete() }}>Delete</Button>}
                        <Button size='small' variant='outlined' sx={{ textTransform: 'capitalize', width: '5vw' }} disabled={!!TempId} onClick={() => {
                            if (!TempId) {
                                setFormState((prevState) => ({
                                    ...prevState,
                                    therapyName: null,
                                    therapyCode: ''
                                }));
                                setIsActive(true);
                            }
                        }}>Clear</Button>
                        <Button size='small' variant='contained' disabled={medicineDetails.length <= 0 && !commonDisable} sx={{ textTransform: 'capitalize', width: '5vw' }} onClick={() => { AddTherapyMappingData() }}>{TempId ? 'Update' : 'Save'}</Button>
                    </Box>
                </Box>
                <Box component={'div'} style={{ display: 'flex', flexDirection: 'row', alignItems: "center", height: "9vh", paddingLeft: "0.5vw" }}>
                    {textBox("Therapy Code", 'therapyCode', formState?.therapyCode, '15vw', !!TempId)}
                    {TempId ? (
                        <TextField size="small" label="Therapy Name" value={typeof formState?.therapyName === 'object' ? (formState?.therapyName?.treatment_name || '') : (formState?.therapyName || '')} sx={{ width: '15vw', marginRight: '0.3vw' }} InputProps={{ readOnly: true }} />
                    ) : (
                        autoComplete("Select Therapy Name", 'therapyName', formState?.therapyName, formState?.therapyList, '15vw', false)
                    )}
                    <FormControlLabel control={<Checkbox checked={isActive} onChange={(e) => { setIsActive(e.target.checked) }} size='small' />} label={"Active"} />
                </Box>
            </Box>

            <Box component={'div'} sx={{ width: '93vw', backgroundColor: 'white', mt: "0.5vw" }}>
                <Box component={'div'} height={'5vh'} display={'flex'} alignItems={'center'} justifyContent={'space-between'} sx={{ backgroundColor: 'white', borderBottom: '1px solid lightgray', paddingLeft: "0.5vw", paddingRight: "0.5vw" }}>
                    <Typography color={Colors.SecondaryText} fontWeight={600} fontSize={"0.95vw"}>{'Add Medicine'}</Typography>
                    <Box sx={{ display: 'flex', gap: '0.5vw' }}>
                        <Button variant='outlined' sx={{ textTransform: 'capitalize', width: '7vw' }} onClick={() => {
                            setEditingDrugSno(null);
                            setFormState((prevState) => ({ ...prevState, medicineRow: { ...default_medicine } }));
                        }}>Clear</Button>
                        <Button variant='contained' disabled={!commonDisable || !formState.medicineRow.drug_id || !formState.medicineRow.quantity || !formState.medicineRow.uom} sx={{ textTransform: 'capitalize', width: '7vw' }} onClick={() => { AddTable() }}>
                            {editingDrugSno != null ? 'Update' : 'Add'}
                        </Button>
                    </Box>
                </Box>
                <Box component={'div'} sx={{ padding: "0.5vw", maxHeight: '30vh', overflowY: 'auto' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.5vw' }}>
                        {/* Main Medicine */}
                        <Box sx={{ display: 'flex', gap: '0.5vw', alignItems: 'center', flexWrap: 'wrap' }}>
                            <Box sx={{ width: '30vw' }}>
                                {editingDrugSno != null ? (
                                    <TextField size="small" label="Medicine Name" value={formState.medicineRow.drug_name || ''} sx={{ width: '100%' }} InputProps={{ readOnly: true }} />
                                ) : (
                                    autoComplete("Search Medicine*", 'selectedMedicine', selectedMainMedicine, formState.medicineRow.medicineList || [], '100%', false, (e, newValue, reason) => handleMedicineInputChange(e, newValue, reason))
                                )}
                            </Box>
                            <Box sx={{ width: '10vw' }}>
                                <TextField
                                    size='small'
                                    label="Quantity*"
                                    value={formState.medicineRow.quantity}
                                    onChange={(e) => onChangeHandler(e, 'quantity')}
                                    sx={{ width: '100%' }}
                                    inputProps={{ maxLength: 5, inputMode: 'numeric', pattern: '[0-9]*' }}
                                />
                            </Box>
                            <Box sx={{ width: '10vw' }}>
                                <FormControl size='small' sx={{ width: '100%' }}>
                                    <InputLabel>Unit*</InputLabel>
                                    <Select
                                        value={formState.medicineRow.uom || ''}
                                        label="Unit*"
                                        onChange={(e) => onChangeHandler(e, 'uom')}
                                        displayEmpty
                                    >
                                        {getUomOptions(formState.medicineRow).map((uom) => (
                                            <MenuItem key={uom} value={uom}>
                                                {uom}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={formState.medicineRow.is_billable}
                                            onChange={(e) => setFormState((prev) => ({
                                                ...prev,
                                                medicineRow: { ...prev.medicineRow, is_billable: e.target.checked }
                                            }))}
                                            size='small'
                                        />
                                    }
                                    label="Billable"
                                />
                            </Box>
                            <IconButton
                                size="small"
                                onClick={handleAddCombination}
                                disabled={!commonDisable || !formState.medicineRow.drug_id}
                                color="primary"
                            >
                                <AddIcon />
                            </IconButton>
                        </Box>
                        {/* Combination Medicines */}
                        {formState.medicineRow.combinations?.map((combination, combIndex) => {
                            const selectedCombMedicine = combination.medicineList?.find(item =>
                                item?.drug_name === combination.drug_name
                            ) || null;
                            return (
                                <Box key={`comb-${combIndex}`} sx={{ display: 'flex', gap: '0.5vw', alignItems: 'center', flexWrap: 'wrap', paddingLeft: '2vw' }}>
                                    <Box sx={{ width: '30vw' }}>
                                        {editingDrugSno != null ? (
                                            <TextField size="small" label="Combination Medicine" value={combination.drug_name || ''} sx={{ width: '100%' }} InputProps={{ readOnly: true }} />
                                        ) : (
                                            autoComplete(
                                                "Search Combination Medicine*",
                                                'selectedCombinationMedicine',
                                                selectedCombMedicine,
                                                combination.medicineList || [],
                                                '100%',
                                                false,
                                                (e, newValue, reason) => handleMedicineInputChange(e, newValue, reason, combIndex),
                                                combIndex
                                            )
                                        )}
                                    </Box>
                                    <Box sx={{ width: '10vw' }}>
                                        <TextField
                                            size='small'
                                            label="Quantity*"
                                            value={combination.quantity}
                                            onChange={(e) => onChangeHandler(e, 'quantity', combIndex)}
                                            sx={{ width: '100%' }}
                                            inputProps={{ maxLength: 5, inputMode: 'numeric', pattern: '[0-9]*' }}
                                        />
                                    </Box>
                                    <Box sx={{ width: '10vw' }}>
                                        <FormControl size='small' sx={{ width: '100%' }}>
                                            <InputLabel>Unit*</InputLabel>
                                            <Select
                                                value={combination.uom || ''}
                                                label="Unit*"
                                                onChange={(e) => onChangeHandler(e, 'uom', combIndex)}
                                                displayEmpty
                                            >
                                                {getUomOptions(combination).map((uom) => (
                                                    <MenuItem key={uom} value={uom}>
                                                        {uom}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                    {commonDisable && (
                                        <IconButton size="small" color="error" onClick={() => handleDeleteCombinationInForm(combIndex)} title="Delete combination">
                                            <DeleteIcon fontSize="small" />
                                        </IconButton>
                                    )}
                                </Box>
                            );
                        })}
                    </Box>
                </Box>
            </Box>

            <Box component={'div'} sx={{ height: '43vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white', }}>
                {tableView()}
            </Box>

            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose}
                />
                : null}
            {isDelete ?
                <DeletePopup
                    DeletTitle={
                        (medicineLineItem?.length === delIDs.length && apiDeleteIDs.length > 0)
                            ? "Are you sure? Deleting this will remove the entire mapping!"
                            : "Are you sure, Do you want to delete this item?"
                    }
                    DeleteNotify={
                        (medicineLineItem?.length === delIDs.length && apiDeleteIDs.length > 0)
                            ? "If you remove this, the entire mapping will be deleted."
                            : "If you remove this, this could affect the entire Configuration."
                    }
                    deleteAlertPopupClose={closeFilter}
                    removeData={deleteIndivudualData}
                />
                : null}
            {deleteRow ?
                <DeletePopup
                    DeletTitle="Are you sure you want to delete this medicine?"
                    DeleteNotify="This action cannot be undone."
                    deleteAlertPopupClose={() => setDeleteRow(null)}
                    removeData={deleteSingleRow}
                />
                : null}
            {deleteCombRow ?
                <DeletePopup
                    DeletTitle="Are you sure you want to delete this combination drug?"
                    DeleteNotify="Only this combination will be removed; the main drug will remain."
                    deleteAlertPopupClose={() => setDeleteCombRow(null)}
                    removeData={deleteSingleCombination}
                />
                : null}
            <Loader loaderOpen={isloader} />
        </Box>
    )
}
